<h1 mat-dialog-title class="font-type main-font">Modifica Password</h1>
<mat-dialog-content class="main-font">
  <form [formGroup]= "profileForm">
    <div class="container">
      <div class="mt-5">
        <mat-form-field appearance="fill" color="primary" class="col-12">
          <mat-label>Password Attuale</mat-label>
          <input [type]="showCurrent ? 'text' : 'password'" matInput formControlName="current_password">

          <span class="me-2" (click)="switchCurrent()" matSuffix>
              <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showCurrent, 'closed-eye': !showCurrent}"></mat-icon>
          </span>
        </mat-form-field>

        <mat-form-field appearance="fill" color="primary" class="col-12">
          <mat-label>Nuova Password</mat-label>
          <input [type]="showNew ? 'text' : 'password'" matInput formControlName="password">

          <span class="me-2" (click)="switchNew()" matSuffix>
            <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showNew, 'closed-eye': !showNew}"></mat-icon>
          </span>
        </mat-form-field>

        <mat-form-field appearance="fill" color="primary" class="col-12">
          <mat-label>Verifica Nuova Password</mat-label>
          <input [type]="showConfirm ? 'text' : 'password'" matInput formControlName="confirm_password">

          <span class="me-2" (click)="switchConfirm()" matSuffix>
            <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showConfirm, 'closed-eye': !showConfirm}"></mat-icon>
          </span>
        </mat-form-field>
        <!-- <p class="error-p" *ngIf="profileForm.controls['confirm_password'].invalid && profileForm.controls['confirm_password'].dirty">La password deve contenere almeno 8 caratteri</p> -->

        <div *ngIf="profileForm.controls['current_password'].value == profileForm.controls['password'].value && profileForm.controls['current_password'].value != ''">
          <p class="error-p">La nuova password non può coincidere con vecchia password</p>
        </div>

        <div *ngIf="profileForm.controls['confirm_password'].dirty">
          <p class="error-p" *ngIf="profileForm.controls['password'].invalid && profileForm.controls['password'].dirty">La nuova password deve contenere almeno 8 caratteri</p>
          <p class="error-p"  *ngIf="profileForm.controls['password'].valid && profileForm.hasError('notSame')">La nuova password non coincide con la verifica</p>
          <!-- <p *ngIf="errorFlag">Autenticazione password fallita</p> -->
        </div>


      </div>
    </div>
  </form>
  <mat-dialog-actions class="buttons justify-content-end main-font">
    <button mat-raised-button mat-dialog-close>Annulla</button>
    <button mat-raised-button color="accent" [disabled]="profileForm.invalid || profileForm.errors || (profileForm.controls['current_password'].value == profileForm.controls['password'].value)"
    (click)="changePassword()">Salva</button>
  </mat-dialog-actions>
</mat-dialog-content>
